export const PROFILE_SELECTOR_ROUTE = '/identity/profile-selector'
export const PROFILE_SETUP_ROUTE = '/identity/profile-setup'

/** A profile-flow path that carries `returnTo` along, as GH's `?returnTo=` suffix does. */
export function profileFlowUrl(route: string, returnTo: string | undefined): string {
    return returnTo ? `${route}?${new URLSearchParams({ returnTo })}` : route
}

/** GH's Add Profile: suggest the household's un-enrolled profiles first, else create one. */
export function addProfileUrl(suggestions: boolean, returnTo: string | undefined): string {
    return profileFlowUrl(suggestions ? PROFILE_SELECTOR_ROUTE : PROFILE_SETUP_ROUTE, returnTo)
}

/** GH's setup-complete screen for a profile just created or imported. */
export function profileSetupCompleteUrl(profileId: string): string {
    return `${PROFILE_SETUP_ROUTE}?${new URLSearchParams({ id: profileId })}`
}
